import React, { Component } from 'react';
import SelectField from 'components/form/select-field';
import { observer } from 'mobx-react';
import rootStore from 'store/rootStore';

@observer
class CategoryPicker extends Component {
    render() {
        const options = rootStore.categories.categories.map((category) => ({
            label: category.name,
            options: [
                {
                    value: category.id,
                    label: category.name,
                },
                ...category.categories.map((item) => ({
                    value: item.id,
                    label: item.name,
                }))
            ],
        }));

        return (
            <SelectField
                options={options}
                isLoading={rootStore.categories.loading}
                {...this.props}
            />
        )
    }
}

export default CategoryPicker;


// WEBPACK FOOTER //
// ./src/components/pickers/category-picker.js